module.exports = __webpack_public_path__ + "static/img/shi.df46ace.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/shi.png
// module id = KTvz
// module chunks = 1